var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcPopover',{attrs:{"popup-role":"dialog","shown":_vm.showIconPicker},on:{"update:shown":function($event){_vm.showIconPicker=$event}},scopedSlots:_vm._u([{key:"trigger",fn:function(slotProps){return [_vm._t("default",null,null,slotProps)]}}],null,true)},[_vm._v(" "),_c('IconPicker',{attrs:{"icons":_vm.icons},on:{"select":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }